module.exports = Object.freeze({
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  RESET: 'RESET',
  CHANGE_CHANNEL: 'CHANGE_CHANNEL',
  INITIAL_LOAD: 'INITIAL_LOAD',
  LOAD_MORE: 'LOAD_MORE',
  ADD_MESSAGE: 'ADD_MESSAGE',
  EDIT_MESSAGE: 'EDIT_MESSAGE',
  CLEAR_PUBLIC_MESSAGES: 'CLEAR_PUBLIC_MESSAGES',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  EDIT_USER: 'EDIT_USER',
  MARK_AS_QUESTION: 'MARK_AS_QUESTION',
  UNMARK_AS_QUESTION: 'UNMARK_AS_QUESTION',
  UNMARK_ALL_AS_QUESTIONS: 'UNMARK_ALL_AS_QUESTIONS'
})
